import React from 'react'
import { Anchor, BreastContainer, ErrorDescription, ErrorTitle, LegendCriteriaSection, Text } from './styles'
import { BreastCancerPrs } from '../breastCancerPrs'
import { usePatient } from '~/context'
import { useFetchBreastCancerPRS } from '~/hooks'
import { SpinnerIconLoader } from '~/components/shared'
import { IconComponent } from '~/assets/icons/component'
import { message } from '~/services'
import { Center, Stack } from '~/styles'

const LegendCriteria = (): JSX.Element => (
  <Stack>
    <LegendCriteriaSection>
      <Text>
        O câncer de mama é uma doença complexa e que possui um importante componente genético para o seu
        desenvolvimento. O escore de risco poligênico é uma das ferramentas capazes de avaliar esse risco genético a
        partir da combinação de diversas variantes genéticas que individualmente possuem pouco impacto, porém quando
        acumuladas representam um risco elevado para o desenvolvimento da doença.
      </Text>
    </LegendCriteriaSection>
    <LegendCriteriaSection>
      <Text>
        Este escore de risco de poligênico para câncer de mama foi criado com base no modelo reconhecido na literatura
        científica desenvolvido por Mavaddat e colaboradores (DOI:{' '}
        <Anchor href="https://www.cell.com/ajhg/fulltext/S0002-9297(18)30405-1" target="_blank">
          10.1016/j.ajhg.2018.11.002
        </Anchor>
        ) e validado para população brasileira internamente (DOI:{' '}
        <Anchor href="https://www.medrxiv.org/content/10.1101/2022.09.09.22279721v1" target="_blank">
          10.1101/2022.09.09.22279721
        </Anchor>
        ).
      </Text>
    </LegendCriteriaSection>
    <LegendCriteriaSection>
      <Text>
        Esse modelo conta com a avaliação de 313 variantes genômicas distintas. Seguindo as melhores práticas, apenas os
        indivíduos portadores dos maiores escores (99%-100%) são considerados como alto risco para o desenvolvimento do
        câncer de mama.
      </Text>
    </LegendCriteriaSection>
  </Stack>
)

export const GenomicRiskScore = (): JSX.Element => {
  const { getVisiblePatientId } = usePatient()
  const patientId = getVisiblePatientId()
  const { data, isLoading, error } = useFetchBreastCancerPRS({ pathParams: { patientId: String(patientId) } })

  if (isLoading) {
    return (
      <Center background="#fff" borderRadius="8px">
        <SpinnerIconLoader iconComponent={<IconComponent name={'loading'} />} size={75} velocity={2} />
      </Center>
    )
  }

  if (error) {
    return (
      <Center background="#fff" borderRadius="8px" flexDirection="column">
        <IconComponent name="worksheets" />
        <ErrorTitle>{message('analyticalModels.not_found_title')}</ErrorTitle>
        <ErrorDescription>{error.message}</ErrorDescription>
      </Center>
    )
  }

  if (data)
    return (
      <BreastContainer>
        <BreastCancerPrs flex={1} border="1px solid #DCE3ED" prs={data} />
        <LegendCriteria />
      </BreastContainer>
    )
  return <></>
}
